import React from "react";
import { useSelector } from "react-redux";
const HighlightedList = () => {
  const items = useSelector((state) => state.category?.items);
  return (
    <div className="grid grid-cols-1 gap-4 ">
      {items.map((item) => (
        <div
          key={item.id}
          className="relative w-full h-28 rounded-lg overflow-hidden shadow-md"
          style={{
            backgroundImage: `url(${item.image})`,
            backgroundSize: "contain",
            backgroundPosition: "center",
          }}
        >
          <div
            className={`absolute inset-0 bg-gradient-to-r ${item.gradient} to-transparent opacity-70`}
          ></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <h2 className="text-white text-lg md:text-2xl font-semibold text-center">
              {item.title}
            </h2>
          </div>
        </div>
      ))}
      {/* <button className="btn btn-warning btn-sm py-2 px-4 rounded-lg">
        Xem tất cả
      </button> */}
    </div>
  );
};

export default HighlightedList;
